import React from "react";
import Markdown from "react-markdown";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import rehypeRaw from "rehype-raw";

interface ProjectDetailsProps {
  title: string;
  image?: string;
  markdownContent: string;
  onClose: () => void;
}

const CodeBlock = ({ className, children }: any) => {
  const language = className?.replace("language-", "") || ""; // Extract language (e.g., "gql", "javascript")
  return (
    <SyntaxHighlighter style={oneDark} customStyle={{maxHeight:"500px"}} language={language}>
      {String(children).trim()}
    </SyntaxHighlighter>
  );
};

const ProjectDetails = ({ title, image, markdownContent, onClose }: ProjectDetailsProps) => (
  <div className="p-3">
    <div className="relative lg:max-w-4xl mx-auto p-6 bg-white rounded-xl shadow-xl border-l-4 border-blue-400">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-3xl font-bold">{title}</h1>
        <button
          className="text-gray-400 hover:text-gray-600 text-xl"
          onClick={onClose}
        >
          &#10005;
        </button>
      </div>
      {/* Optional image display */}
      <div className="prose max-w-full w-full project-markdown">
        <Markdown
          rehypePlugins={[rehypeRaw]} // Use rehypeRaw for raw HTML support
          components={{
            code: CodeBlock, // Override the default code renderer
          }}
        >
          {markdownContent}
        </Markdown>
      </div>
    </div>
  </div>
);

export default ProjectDetails;
